<template>
    <div class="content-body" style="padding-top: 6rem">
        <div class="container-fluid">
            <div class="page-titles">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Slider</a>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{ name: 'Testimoni' }">Data Apa Kata Mereka</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">{{ currentRouteName }}</a>
                    </li>
                </ol>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Form {{ currentRouteName }}</h4>
                        </div>
                        <div class="card-body">
                            <div class="basic-form">
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Nama Lengkap
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input v-model="post.nama" @input="generateSlug" type="text" class="form-control" placeholder="Nama Lengkap" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Perusahaan
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input v-model="post.nama_perusahaan" type="text" class="form-control" placeholder="Perusahaan" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">Slug URL</label>
                                    <div class="col-sm-9">
                                        <input v-model="post.slug" type="text" class="form-control" placeholder="Slug URL" readonly />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Foto
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <div class="input-group">
                                            <div class="custom-file">
                                                <input @change="handleFileUpload" type="file" class="custom-file-input" />
                                                <label class="custom-file-label">{{ post.image ? post.image.name : "Pilih file" }}</label>
                                            </div>
                                        </div>
                                        <!-- Preview Gambar -->
                                        <div v-if="imagePreview" class="mt-3">
                                            <img :src="imagePreview" alt="Preview" class="img-thumbnail" />
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Deskripsi
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <textarea ref="summernote" class="form-control summernote" id="deskripsi" v-model="post.deskripsi" rows="3"></textarea>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">Embed</label>
                                    <div class="col-sm-9">
                                        <input v-model="post.embed" type="text" class="form-control" placeholder="Url Video" />
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">Status</label>
                                    <div class="col-sm-9">
                                        <select v-model="post.is_publish" class="form-control">
                                            <option value="true">Publish</option>
                                            <option value="false">Unpublish</option>
                                        </select>
                                    </div>
                                </div>
                                <button type="button" @click="goBack" class="btn btn-warning btn-sm mr-1">Kembali</button>
                                <button type="button" @click="submit" class="btn btn-primary btn-sm mr-1">Simpan</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted, ref, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axiosInstance from "../../axios";

export default {
    name: "Tambah Testimoni",
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const summernote = ref(null);
        const imagePreview = ref(null);
        const currentRouteName = computed(() => route.name);

        const post = ref({
            nama: "",
            slug: "",
            image: null,
            nama_perusahaan: "",
            deskripsi: "",
            embed: "",
            is_publish: "",
            user: null,
            id_kategori: 11,
        });

        const isAuthenticated = computed(() => store.getters.isAuthenticated);
        const token = computed(() => store.getters.token);
        const tokenExpiry = computed(() => store.getters.tokenExpiry);
        const id_kategori = post.value.id_kategori;

        if (!token.value || !tokenExpiry.value || new Date() > new Date(tokenExpiry.value) || !isAuthenticated.value) {
            Swal.fire({
                title: "Error",
                text: `Session expired or invalid`,
                icon: "error",
                confirmButtonText: "OK",
            }).then(() => {
                store.dispatch("setAuth", false);
                store.dispatch("setToken", { token: null, expiry: null });
                localStorage.clear();
                router.replace({ name: "Login" });
            });
            return;
        }

        const fetchUser = async () => {
            try {
                const response = await axiosInstance.get("/user", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token.value}`,
                    },
                });
                if (response.status === 200) {
                    post.value.user = response.data.id;
                } else {
                    throw new Error("User not found");
                }
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: error.message,
                    icon: "error",
                    confirmButtonText: "OK",
                }).then(() => {
                    store.dispatch("setAuth", false);
                    store.dispatch("setToken", { token: null, expiry: null });
                    localStorage.clear();
                    router.replace({ name: "Login" });
                });
            }
        };

        const handleFileUpload = (event) => {
            const file = event.target.files[0];
            const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml"];
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes

            // Validate file type
            if (!validTypes.includes(file.type)) {
                Swal.fire({
                    title: "Invalid File Type",
                    text: "Please select an image with format jpeg, jpg, png, or svg.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                return;
            }

            // Validate file size
            if (file.size > maxSize) {
                Swal.fire({
                    title: "File Too Large",
                    text: "Please select an image smaller than 2MB.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                return;
            }

            post.value.image = file;

            // Create image preview
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    imagePreview.value = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        };

        const goBack = () => {
            router.push({ name: "Testimoni" });
        };

        const checkTitleExistence = async () => {
            try {
                const response = await axiosInstance.get(`/blog-slug/${post.value.slug}`, {
                    headers: {
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                console.log("Response data:", response.data);

                // Check if the response indicates the title already exists
                if (response.data.success && response.data.message === "Title Sudah Digunakan") {
                    Swal.fire({
                        title: "Warning",
                        text: "The slug already exists, please choose another title.",
                        icon: "warning",
                        confirmButtonText: "OK",
                    });
                    post.value.slug = ""; // Clear the slug if it exists
                }
            } catch (error) {
                console.error("Error checking slug existence", error);
            }
        };

        const generateSlug = async () => {
            post.value.slug = post.value.nama
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/^-+|-+$/g, "");

            await checkTitleExistence();
        };

        const submit = async () => {
            post.value.deskripsi = $(summernote.value).summernote("code");
            const formData = new FormData();
            formData.append("nama", post.value.nama);
            formData.append("nama_perusahaan", post.value.nama_perusahaan);
            formData.append("slug", post.value.slug);
            formData.append("embed", post.value.embed);
            formData.append("deskripsi", post.value.deskripsi);
            formData.append("is_publish", post.value.is_publish);
            formData.append("user", post.value.user);
            formData.append("id_kategori", id_kategori);
            if (post.value.image) {
                formData.append("image", post.value.image);
            }

            try {
                const response = await axiosInstance.post("/testi", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        title: "Success",
                        text: "Data created successfully!",
                        icon: "success",
                        confirmButtonText: "OK",
                    }).then(() => {
                        goBack();
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Error creating data",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: `Error: ${error.message}`,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        };

        onMounted(async () => {
            await fetchUser();
            await nextTick();
            $(summernote.value).summernote({
                height: 200,
                callbacks: {
                    onChange: (contents) => {
                        post.value.deskripsi = contents;
                    },
                },
            });
        });

        return {
            post,
            fetchUser,
            currentRouteName,
            generateSlug,
            submit,
            goBack,
            handleFileUpload,
            summernote,
            imagePreview,
        };
    },
};
</script>
